/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type appAzureActiveDirectory_QueryVariables = {};
export type appAzureActiveDirectory_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"appAzureActiveDirectory_viewer">;
    } | null;
};
export type appAzureActiveDirectory_Query = {
    readonly response: appAzureActiveDirectory_QueryResponse;
    readonly variables: appAzureActiveDirectory_QueryVariables;
};



/*
query appAzureActiveDirectory_Query {
  viewer {
    actualPersonId
    component(name: "app_azure_active_directory")
    ...appAzureActiveDirectory_viewer
    id
  }
}

fragment appAzureActiveDirectory_viewer on Viewer {
  id
  company {
    id
    AADEnabled
    oneloginEnabled
    oktaEnabled
    scimUsernamePassword
    AADTenant
    AADClientId
    AADClientSecret
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "app_azure_active_directory"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"app_azure_active_directory\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appAzureActiveDirectory_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appAzureActiveDirectory_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appAzureActiveDirectory_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "AADEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "oneloginEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "oktaEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scimUsernamePassword",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "AADTenant",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "AADClientId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "AADClientSecret",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "appAzureActiveDirectory_Query",
    "operationKind": "query",
    "text": "query appAzureActiveDirectory_Query {\n  viewer {\n    actualPersonId\n    component(name: \"app_azure_active_directory\")\n    ...appAzureActiveDirectory_viewer\n    id\n  }\n}\n\nfragment appAzureActiveDirectory_viewer on Viewer {\n  id\n  company {\n    id\n    AADEnabled\n    oneloginEnabled\n    oktaEnabled\n    scimUsernamePassword\n    AADTenant\n    AADClientId\n    AADClientSecret\n  }\n}\n"
  }
};
})();
(node as any).hash = '2d4cc4fe0044d7276f98c45302e70719';
export default node;
